import { useContext } from "react";
import { DateFiltersContext } from ".";
import { type DateFiltersState } from "../types";

export const useDateFilters = () => {
    const context = useContext<DateFiltersState>(DateFiltersContext);

    if (!context) {
        throw Error("useDateFilters without provider");
    }

    return context;
}
